/**
 * ============================================================================
 * RevenueHeader - PAGE HEADER WITH TITLE
 * ============================================================================
 *
 * Clean header with title only.
 * Export button moved to source filter area.
 *
 * ============================================================================
 */

import React from 'react';

/**
 * Revenue page header with title
 */
export function RevenueHeader() {
  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-black text-gray-900 mb-1">Revenue & Payouts</h1>
      <p className="text-gray-600 text-sm">Track your earnings and payout history</p>
    </div>
  );
}
